import { render, staticRenderFns } from "./OctMenuList.vue?vue&type=template&id=d8506474&scoped=true&"
import script from "./OctMenuList.vue?vue&type=script&lang=js&"
export * from "./OctMenuList.vue?vue&type=script&lang=js&"
import style0 from "./OctMenuList.vue?vue&type=style&index=0&id=d8506474&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8506474",
  null
  
)

export default component.exports